<template>
  <div>

    <b-container class="flex_center_page max_500">
      <b-row class="justify-content-center max_500">
        <b-col >
          <b-card no-body class="border-0 mb-0 max_500">
            
            <b-card-body>
              <h1>Log In</h1>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator" v-if="has_orgs === false">
                <b-form role="form" @submit.prevent="handleSubmit(get_orgs)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="email"
                              placeholder="Email"
                              v-model="email">
                  </base-input>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4" :disabled="is_loading" active>Next</base-button>
                  </div>
                </b-form>
              </validation-observer>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator" v-else-if="has_orgs === true">
                <b-form role="form" @submit.prevent="handleSubmit(submit_login)">
                  {{email}}
                  <div v-if="orgs && orgs.length > 0">
                    <base-input label="Organization">
                      <el-select v-model="org_id" filterable
                          autofocus=true
                          placeholder="Org">
                        <el-option v-for="org in orgs"
                                  :key="org.org_id"
                                  :label="org.org_name"
                                  :value="org.org_id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div v-else>
                    <h2>Error. Must have access to at least one org. Contact admin.</h2>
                  </div>

                  <!-- required: true, is auto focusing just remove-->
                  <base-input alternative 
                              class="mb-3"
                              name="Password"
                              :rules="{ min: 6}"
                              prepend-icon="lock"
                              type="password"
                              placeholder="Password"
                              autofocus=false
                              v-model="password">
                  </base-input>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4" :disabled="is_loading" active>Log In</base-button>
                  </div>
                </b-form>
              </validation-observer>

            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/password" ><small>Forgot password?</small></router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <small>Contact campaign to get an account</small>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { Modal, BaseAlert } from '@/components';
  import { Select, Option } from 'element-ui';

  export default {
    components: {
    
      [Select.name]: Select,
      [Option.name]: Option
    },
    data() {
      return {
        has_orgs: false,
        is_loading: false,
        email: null,
        password: null,
        orgs: [

        ],
        org_id: null
      };
    },
    mounted: function() {
      try {
        if (localStorage.getItem('active_user_jwt')) {
          localStorage.removeItem('active_user_jwt')
        }
      } catch(e) {
        console.log(e)
      }
    },
    methods: {
      get_orgs() {
        this.is_loading = true

        console.log(this.email)

        axios.get('https://fullstackapp-dot-smiling-garden-126003.appspot.com/admin/user_org', { 
          params: {
            email: this.email
          }
        })
        .then((response,error) => {
          if(error) {
            console.log(JSON.stringify(error))
            swal.fire({
              title: `Warning`,
              text: 'Error. Do you have an account? Please contact admin.',
              buttonsStyling: false,
              icon: 'warning'
            })
          }

          if(response) {
            if(response.data && response.data.length && response.data.length > 0) {
              this.orgs = response.data
              this.has_orgs = true
            } else {
              swal.fire({
                title: `Warning`,
                text: 'Error. Do you have an account? Please contact admin.',
                buttonsStyling: false,
                icon: 'warning'
              })
            }
          }

          this.is_loading = false



        })
      },
     clear_state() {
        
        this.email = null
        this.org_id = null
        this.password = null
        this.orgs = []
        this.has_orgs = false
        this.is_loading = false
      },
      submit_login() {
        this.is_loading = true

        if(!this.password || !this.org_id ||  !this.email) {
          this.clear_state()
          return swal.fire({
              title: `Warning`,
              text: 'Fill in all fields',
              buttonsStyling: false,
              icon: 'warning'
            })
        } else {
          axios.post('https://fullstackapp-dot-smiling-garden-126003.appspot.com/admin/login', 
            {
              org_id: this.org_id,
              email: this.email,
              password: this.password
            }
          )
          .then((response,error) => {
            if(error) {
              this.clear_state()
              console.log(JSON.stringify(error))
              return swal.fire({
                title: `Warning`,
                text: 'Error. Please contact admin.',
                buttonsStyling: false,
                icon: 'warning'
              })
            }

            if(response) {
              //console.log(JSON.stringify(response))
              //console.log(JSON.stringify(response.data))
              if(response.status && response.status === 404) {
                
                this.clear_state()
                return swal.fire({
                  title: `Warning`,
                  text: 'Incorrect password or data',
                  buttonsStyling: false,
                  icon: 'warning'
                })
              }
              if(response.data && response.data.authenticated && response.data.authenticated === true) {
                //console.log('debug 179 got user login and jwt')
                //console.log(JSON.stringify(response.data))

                if(response.data.active_user_jwt) {
                 
                  //store active_user_jwt
                  localStorage.setItem('active_user_jwt',response.data.active_user_jwt)
                  sessionStorage.setItem('active_user_jwt',response.data.active_user_jwt)

                  this.$router.push('home')
                  //this.$router.go('/home')
                }
              } else {
                console.log(JSON.stringify(response))
                this.clear_state()
                return swal.fire({
                  title: `Warning`,
                  text: 'Incorrect password or data',
                  buttonsStyling: false,
                  icon: 'warning'
                })
              }
            } 


          })
          .catch((error) => {
            console.log('is error')
            console.log(error)
            this.clear_state()
            return swal.fire({
              title: `Warning`,
              text: 'Incorrect password or data',
              buttonsStyling: false,
              icon: 'warning'
            })
           
          })
        }

        

      
      }
    }
  };
</script>
<style>
.flex_center_page {
  display: flex; 
  align-items: center; 
  justify-content: center;
  margin-top: 50px;
}
.max_500 {
  max-width: 500px;
  width: 100%;
}
</style>